module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_09@2x-7f73b5fd101a334da34231da0d4b9fee.jpg";